<template>
    <div class="login-bg">
        <div class="login-main-box">
            <h3>注册</h3>
            <!-- <div class="input-box">
                <input type="text" placeholder="请输入手机号" />
                <div class="input-tips">账号输入错误</div>
            </div>
            <div class="input-box">
                <input type="text" placeholder="请输入验证码" />
                <div class="input-tips">账号输入错误</div>
                <a href="javascript:;" class="input-vercode">输入验证码</a>
            </div>
            <div class="input-box">
                    <input type="text" placeholder="设置密码" />
            </div> -->
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                <el-form-item prop="phone">
                    <el-input v-model="ruleForm.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item prop="code" class="cap_fu">
                    <el-input v-model="ruleForm.code" maxlength="6" placeholder="请输入验证码"></el-input>
                    <span v-show="show" class="cap_submit hxcursor" @click="getCap">获取验证码</span>
                    <span v-show="!show" class="cap_submit hxcursor" style="background:gray;">重新发送({{count}})</span>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input v-model="ruleForm.password" placeholder="请输入密码" type="password"></el-input>
                </el-form-item>
            </el-form>
            <div class="input-right-register">已有账号？去<a href="javascript:;" @click="toLogin">登录</a></div>
            <button class="login-button" :plain="true" @click="submitForm('ruleForm')">注册</button>
        </div>
        
    </div>
</template>

<script>
export default {
        name: 'Login',
        data () {
            return {
                ruleForm: {
                    phone: '',
                    password: '',
                    code: '',
                },
                rules: {
                    phone: [
                        { required: true, message:'手机号不能为空', trigger:'blur' },
                        { pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, message: '请输入正确的手机号' },
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                    code: [
                        { required: true, message: '请输入验证码', trigger: 'blur' }
                    ]
                },
                //倒计时 ————start————
                show: true,
                count: '',
                timer: null,
                //倒计时 ————end————
                errormes: '', //注册错误信息
            }
        },
        mounted(){
            this.baseUrl = window.baseUrl;
            this.config = window.config;
        },
        methods: {
            toLogin:function(){
                this.$router.push({
                    name:'login'
                });
            },    
            //注册
            submitForm(formName) {
                var that = this;
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        //成功事件
                        that.$http.post(that.baseUrl+that.config.registered,that.$qs.stringify(that.ruleForm)).then(function(ev){
                            console.log(ev);
                            if(ev.data.code == 100){
                                that.open2('注册成功');
                            }else{
                                that.errormes = ev.data.message;
                                that.open4(that.errormes);
                            }
                        }).catch(function(error){
                            console.log(error);
                        })
                    } else {
                        that.open4('请检查您的输入');
                        return false;
                    }
                });
            },
            //验证码倒计时功能
            getCode(){
                const TIME_COUNT = 60;
                if (!this.timer) {
                    this.count = TIME_COUNT;
                    this.show = false;
                    this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.show = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000)
                }
            },
            //获取验证码功能
            getCap: function(){
                var that = this;
                console.log(that.ruleForm.phone)

                that.$http.post(that.baseUrl+that.config.smsSend,that.$qs.stringify(that.ruleForm)).then(function(ev){
                    // console.log(ev);
                    if(ev.data.result == 0){
                        that.getCode();
                    }else{
                        that.$message.error(ev.data.errmsg)
                    }
                }).catch(function(error){
                    console.log(error);
                })

                // this.$refs['formName'].validateField('phone',(validMessage)=>{
                //     if (validMessage) {
                //         alert('submit!');
                //     } else {
                //         console.log('error submit!!');
                //         return false;
                //     }
                // });
            },
            //成功信息
            open2(succ_mes) {
                this.$message({
                    message: succ_mes,
                    type: 'success'
                });
                //跳转到登录页面
                this.$router.push({path: '/Login'});
            },
            //错误信息
            open4(mes) {
                this.$message.error(mes);
            }
        },
        created(){

        }
    }

</script>

<style>
.hxcursor{ position: absolute; right:3%; top: 0; padding:0 .3rem; background:#B81C22; color:#fff; border-radius: .1rem;}
.el-input{ margin:0px 3%;width:96%;}
.el-form-item__error{ width: 96%; margin:0 6%;}
.el-input input{ border-radius:10px; border:1px solid #ccc; margin:0px 3%; width:94%;}
</style>


// WEBPACK FOOTER //
// src/pages/Register.vue